import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { CustomLoadingButton } from "../ui/CustomButton";
import { useSelector } from "react-redux";

const ConfirmDialogThree = ({
  isOpen,
  onClose,
  onButtonOne,
  onButtonTwo,
  onButtonThree,
  dialogTitle,
  dialogContent,
  buttonOneTitle = "buttonOneTitle",
  buttonTwoTitle = "buttonTwoTitle",
  buttonThreeTitle = "buttonThreeTitle",
  closeButtonTitle = "No",
}) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [closeLoading, setCloseLoading] = useState(false);
  const { currentTheme } = useSelector((state) => state.theme);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
          color: currentTheme === "dark" ? "#fff" : "#000",
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            // backdropFilter: "blur(5px)", // Apply blur effect
            backgroundColor: "rgba(0, 0, 0, 0.7)", // Semi-transparent dark background
          },
        },
      }}
    >
      {dialogTitle && (
        <DialogTitle
          sx={{
            color: currentTheme === "dark" ? "#fff" : "#000",
          }}
        >
          <h1 style={{ fontSize: "20px", fontWeight: "300" }}>{dialogTitle}</h1>
        </DialogTitle>
      )}
      {dialogContent && (
        <DialogContent
          sx={{
            color: currentTheme === "dark" ? "#fff" : "#000",
          }}
        >
          {dialogContent}
        </DialogContent>
      )}
      <DialogActions style={{ display: "flex", gap: "1px" }}>
        <CustomLoadingButton
          currentTheme={currentTheme}
          iconPosition="end"
          borderRadiusType="left"
          onClick={async () => {
            setConfirmLoading(true);
            try {
              await onButtonOne();
            } catch (error) {
              console.log(error);
            } finally {
              setConfirmLoading(false);
            }
          }}
          disabled={closeLoading}
        >
          {buttonOneTitle}
        </CustomLoadingButton>

        <CustomLoadingButton
          currentTheme={currentTheme}
          iconPosition="end"
          borderRadiusType="none"
          onClick={async () => {
            setConfirmLoading(true);
            try {
              await onButtonTwo();
            } catch (error) {
              console.log(error);
            } finally {
              setConfirmLoading(false);
            }
          }}
          disabled={closeLoading}
        >
          {buttonTwoTitle}
        </CustomLoadingButton>

        {onButtonThree &&
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            borderRadiusType="none"
            onClick={async () => {
              setConfirmLoading(true);
              try {
                await onButtonThree();
              } catch (error) {
                console.log(error);
              } finally {
                setConfirmLoading(false);
              }
            }}
            disabled={closeLoading}
          >
            {buttonThreeTitle}
          </CustomLoadingButton>}

        <CustomLoadingButton
          currentTheme={currentTheme}
          iconPosition="end"
          borderRadiusType="right"
          onClick={async () => {
            setCloseLoading(true);
            try {
              await onClose();
            } catch (error) {
              console.log(error);
            } finally {
              setCloseLoading(false);
            }
          }}
          disabled={confirmLoading} // Disable this button when confirm button is loading
        >
          {closeButtonTitle}
        </CustomLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialogThree;
